class BrandsCarousel extends HTMLElement {
  constructor() {
    super()
    this.swiper = null
  }

  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not loaded')
      return
    }

    const sectionId = this.dataset.sectionId

    const swiperElem = this.querySelector(`#brands-carousel-${sectionId}`)
    if (!swiperElem) return

    const allowMousewheel = this.dataset.allowMousewheel === 'true'
    const allowAutoplay = this.dataset.allowAutoplay === 'true'
    const playInLoop = this.dataset.playInLoop === 'true'
    const autoplayDelay = parseInt(this.dataset.autoplayDelay || '2500', 10)
    const autoplayDisableOnInteraction =
      this.dataset.autoplayDisableOnInteraction === 'true'

    const gapDesktop = parseInt(this.dataset.gapDesktop || '20', 10)
    const gapMobile = parseInt(this.dataset.gapMobile || '12', 10)

    let autoplay = undefined
    if (allowAutoplay) {
      autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: autoplayDisableOnInteraction,
      }
    }

    const prevEl = this.querySelector('.brands-carousel-section__nav-prev')
    const nextEl = this.querySelector('.brands-carousel-section__nav-next')
    const scrollbarEl = this.querySelector('.brands-carousel-section__scrollbar')

    this.swiper = new Swiper(swiperElem, {
      mousewheel: allowMousewheel,
      autoplay,
      loop: playInLoop,
      spaceBetween: gapDesktop,
      slidesPerView: 'auto',
      breakpoints: {
        0: {
          spaceBetween: gapMobile,
        },
        750: {
          spaceBetween: gapDesktop,
        },
      },
      navigation: {
        prevEl,
        nextEl,
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      },
    })
  }

  disconnectedCallback() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true)
    }
  }
}

customElements.define('brands-carousel', BrandsCarousel)
